import React from "react"
import styled from "styled-components"

import { itens } from './data/menu'
import Arrow from './../../svgs/arrow.svg'

const Container = styled.nav`
  background-color: transparent;
  padding-top: 15px;
  padding-bottom: 15px;
  @media(max-width: 796px){
    display: none;
  }
  &.show {
    position: relative;
    z-index: 4;
    overflow: hidden;
    -webkit-overflow-scrolling: touch;
    @media(max-width: 796px){
    position: fixed;
    width: 100%;
    max-width: 100vw;
    height: 101vh;
    background: var(--cPrimaryDark);
    left: 0;
    top: 0;
    bottom: 0;
    /* border-radius: 20px; */
    display: initial;
    /* margin-top: 30px; */
  }
  }
 
  
  /* display: none; */
  /* @media(min-width: 797px){
    
  } */

`
const Lista = styled.ul`
  list-style: none;
  display: flex;
  justify-content: space-between;


  @media(max-width: 796px){
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    height: 100%;
    padding: 10px;
    margin-top: 60px;
    i.action {
      color: #FFF;
      position: absolute;
      right: 15px;
      top: 15px;
      cursor: pointer;
      font-size: 24px;
    }
    
  }
`
const Item = styled.li`
position: relative;
 @media(max-width: 796px){
   
    width: 100%;
    max-width: 301px;
 }
  & + li {
    @media (min-width: 905px){
      margin-left: 0.6em;
    }
      

  @media(max-width: 796px){
    margin-top: 20px;
  
  }
  }

  
  a {
    color: #FFF;
    border: 1px solid transparent;
    border-radius: 0.8em;
    padding: 12px 22px;
    font-size: 0.91rem;
    &[data-btn="true"] {
      border-color: #FFF;
      &:hover,
      &:active,
      &.actived {
        color:  var(--cPrimary);
        background-color: var(--cThird);
        border-color: var(--cThird);
      }
    }
    &:hover,
    &:active,
    &.actived {
      color: var(--cThird);
      border-color: transparent;
      /* font-weight: 700; */
    }



  @media(max-width: 796px){
    display: flex;
    justify-content: center;
    position: relative;
    /* box-shadow: 0px 17px 17px -5px rgba(0,0,0,0.12); */
    /* background: #316AF5; */
    color: #FFF;
    width: 100%;
    border-color: #FFF;
    padding: 17px 31px;
    text-align: center;
    &:hover{
      background: var(--cThird);
      border-color: var(--cThird);
      color: var(--cPrimaryDark);
    }
    i {
      position: absolute;
      right: 25px;
    }
  }

  /* svg {
    display: none;
    @media(max-width: 796px){
      display: inline-block;
      margin-top: 3px;
      path {
        transform: translate(0.707, 0.707);
        fill: none;
        stroke: rgb(255, 255, 255);
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 2;
    }
    }
  } */
  i {
    margin-left: 15px;
  }
}
`

const Menu = ({handle, classTmp, handleMenu}) => (
 <Container className={classTmp}>
   <Lista>
   {classTmp === 'show' &&
      <i className="fas fa-times action" onClick={handleMenu} />
    }
    {
      itens.map((item, key) => (
        <Item key={key} onClick={ () => classTmp === 'show' ? handleMenu() : null}>
          <a  target={item.target} href={item.href} data-btn={item.btn} className={item.active ? 'actived' : ''} onClick={(evt) => item.event === 'contato' ? handle() : null} >
            <span>{item.title}</span>
            {item.icon && <i className={item.icon} />}
            {/* <Arrow /> */}
            </a>
          
        </Item>
      ))
    }
   </Lista>
  
 </Container>
)
export default Menu
